/**
 * 멀티파트 호출의 resourceId 사전 검증 (leaf, import 0개).
 *
 * ⚠️ **이 모듈이 `api/Resource.js` 안이 아니라 여기 있는 이유는 CI 샤드다.** `src/api/` 를
 * 커버하는 잡은 `Test: core` 뿐이고 그 잡은 OOM 때문에 `if: false` 로 꺼져 있다
 * (.github/workflows/frontend-ci.yml:102-104,124) → `api/__tests__/` 의 테스트는 CI 에서
 * 실행되지 않는다. `src/services/` 는 활성 샤드(`Test: services, redux & config`,
 * :300,321)가 커버하므로 검증 로직을 leaf 로 빼서 여기 둔다. uploadQueue.js 를 분리한 것과
 * 같은 이유(테스트가 실제로 돌 곳에 둔다)다.
 */

/** 경로 보간 시 URL 을 오염시키는 값들. 'undefined'/'null' 문자열은 호출부가 이미 보간해 넘긴 경우다. */
const POISON_VALUES = ['', 'undefined', 'null']

/**
 * 멀티파트 4개 API 는 resourceId 를 **URL 경로에** 보간한다. 값이 비면 템플릿 리터럴이
 * `/v1/resources/undefined/files/multipart` 라는 요청을 만들어 서버까지 내보내고, 서버는 그
 * 문자열로 object_key 를 조립해 자기 검증에 걸려 SAFEBOX_852 를 던진다
 * (backend/services/attachment_multipart_service.py:100-101 → api/resource_presigned.py:112-126).
 *
 * 852 는 "이 키가 이 워크스페이스·리소스의 것이 아니다"라는 뜻이라 **진짜 원인(호출부의 id 소실)을
 * 가리켜주지 못한다** — 2026-08-12 dev QA 에서 요청 URL 을 직접 열어보고서야 원인을 찾았다.
 * 경로 조립 직전에서 끊어 실패 지점이 호출부임을 즉시 드러낸다.
 *
 * @throws {Error} code='MISSING_RESOURCE_ID'
 */
export const requireResourceId = (resourceId) => {
  const missing = resourceId == null || POISON_VALUES.includes(resourceId)
  if (!missing) return

  const err = new Error(`multipart call requires a valid resourceId (got: ${String(resourceId)})`)
  err.code = 'MISSING_RESOURCE_ID'
  throw err
}

export default { requireResourceId }
